
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { COMPANY_LIST } from "@/constant";
import {
  searchCustomer
} from "@/api/customer";
import { deepClone } from "@/utils/deepClone";
import { getShippingMarks, putShippingMarks } from "@/api/proforma";
import { DraftModel } from "@/views-oms/asking-for-quotation-management/types";

@Component({
  name: "Marks"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "批量指定唛头" }) private title: "";
  @Prop({ default: "" }) private id: "";
  @Prop({ default: [] }) private selectedList: [];
  private form = {
    piShippingMarks: []
  };

  private newSelectedRows: any[] = [];

  @Watch("selectedList", { immediate: true })
  private async watchData() {
    this.newSelectedRows = deepClone(this.selectedList);
    this.table.list = this.newSelectedRows;
    this.table.list.forEach((item) => {
      item.mainMarkName = item.mainMark;
      item.sideMarkName = item.sideMark;
      item.markLettersName = item.markLetters;
    });
    // console.log(this.newSelectedRows)
  }

  @Watch("id", { immediate: true })
  private async watchId() {
    if (this.id) {
      this.getShippingMarks();
    }
  }

  public info = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [{}] as any[]
  };
  public tableCol = [
    {
      label: "采购订单",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "供应商",
      prop: "supplierAbbreviation",
      key: "supplierAbbreviation",
      show: true,
      disabled: false
    },
    {
      label: "产品品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "主唛",
      prop: "mainMarkName",
      key: "mainMarkName",
      show: true,
      header: true,
      disabled: false
    },
    {
      label: "侧唛",
      prop: "sideMarkName",
      key: "sideMarkName",
      show: true,
      disabled: false
    },
    {
      label: "唛头字母",
      prop: "markLettersName",
      key: "markLettersName",
      show: true,
      disabled: false
    }
  ] as any;

  private list = [
    {
      label: "指定唛头为",
      prop: "piShippingMarks",
      key: "piShippingMarks",
      type: "checkbox",
      placeholder: "请选择唛头",
      options: []
    }
  ];

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    console.log('resresres',res);
    this.list[1].options = res;
  }

  resetForm() {
    this.table.list = deepClone(this.selectedList);
    this.table.list.forEach((item) => {
      item.mainMarkName = item.mainMark;
      item.sideMarkName = item.sideMark;
      item.markLettersName = item.markLetters;
    });
  }

  private async getShippingMarks() {
    const res: any = await getShippingMarks({
      piId: this.id
    });
    res.forEach((item: any) => {
      item.name = item.type +':'+ item.value;
      // item.value = item.piId;
      item.value = item.type +':'+ item.value;
    });
    this.list[0].options = res;
    console.log('1111111111',res)
  }

  private multipleSelection: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.multipleSelection = rows;
  }

  // 批量指定唛头
  private async putShippingMarks(key) {
    const { piShippingMarks } = this.form;
    if (!piShippingMarks.length) {
      this.$message.error("请选择唛头");
      return;
    }
    if (!this.multipleSelection.length) {
      this.$message.error("请选择采购订单");
      return;
    }
    let name_list = [];
    this.list[0].options.forEach((item) => {
      if (piShippingMarks.includes(item.value)) {
        name_list.push(item.name);
      }
    });
    let list = this.multipleSelection.map((item) => {
      return {
        id: item.id,
        [key]: piShippingMarks,
        [`${key}Name`]: name_list.join(",")
      };
    });
    this.table.list.forEach((item) => {
      list.forEach((item2) => {
        if (item.id === item2.id) {
          item[key] = item2[key];
          item[`${key}Name`] = item2[`${key}Name`];
        }
      });
    });
    this.table.list = deepClone(this.table.list);
  }

  private async submitForm() {
    let list = this.table.list.map((item) => {
      console.log('itemitemitemitem',item)
      return {
        id: item.id,
        mainMark: item.mainMark ? Array.isArray(item.mainMark)? item.mainMark.join(",") :item.mainMark : "",
        sideMark: item.sideMark ? Array.isArray(item.sideMark)? item.sideMark.join(",") :item.sideMark : "",
        markLetters: item.markLetters ? Array.isArray(item.markLetters)? item.markLetters.join(",") :item.markLetters : ""
      };
    });
    try {
      await putShippingMarks(list);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }
}
